document.addEventListener("click", async function (event) {
  const sampleButton = event.target.closest('a[href="#order-sample"]');

  if (!sampleButton) return;

  event.preventDefault();

  const stockMessage = document.querySelector(".hob-sample-stock-message");
  const variantId = sampleButton.dataset.sampleVariantId;
  const isAvailable = sampleButton.dataset.sampleAvailable === "true";
  const originalText = sampleButton.textContent;

  if (stockMessage) stockMessage.hidden = true;

  if (!isAvailable) {
    if (stockMessage) {
      stockMessage.textContent =
        "Sample currently out of stock. Please check back in a few days, or contact us for an update.";
      stockMessage.hidden = false;
    }
    return;
  }

  if (!variantId) {
    if (stockMessage) {
      stockMessage.textContent =
        "Sample product is not configured correctly. Please contact us.";
      stockMessage.hidden = false;
    }
    return;
  }

  sampleButton.setAttribute("aria-busy", "true");
  sampleButton.textContent = "Adding...";

  try {
    const response = await fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json"
      },
      body: JSON.stringify({
        id: Number(variantId),
        quantity: 1
      })
    });

    if (!response.ok) throw new Error("Could not add sample to cart");

    sampleButton.textContent = "Sample Added";

    // Prestige cart refresh/open events
    document.documentElement.dispatchEvent(
      new CustomEvent("cart:refresh", { bubbles: true })
    );

    document.documentElement.dispatchEvent(
      new CustomEvent("cart:open", { bubbles: true })
    );

    // Fallback: click cart icon if drawer event does not open it
    setTimeout(function () {
      const cartButton =
        document.querySelector('a[href="/cart"]') ||
        document.querySelector('[aria-controls*="cart"]') ||
        document.querySelector('[data-drawer-id*="cart"]');

      if (cartButton) cartButton.click();
    }, 300);
  } catch (error) {
    console.error(error);

    sampleButton.textContent = originalText;

    if (stockMessage) {
      stockMessage.textContent =
        "Sorry, this sample could not be added to cart. Please try again.";
      stockMessage.hidden = false;
    }
  } finally {
    setTimeout(function () {
      sampleButton.removeAttribute("aria-busy");
      sampleButton.textContent = originalText;
    }, 1200);
  }
});